import * as React from "react";
import styled from "styled-components";
import { Outlet } from "react-router-dom";
import WithGlobalAppNotifications from "components/notifications/WithGlobalAppNotifications";
import { Grid } from "components/bootstrap";
import Footer from "components/layout/Footer";
import useFooterCustomization from "brand-customization/useFooterCustomization";
const Container = styled.div(
  ({ theme }) => `
  display: flex;
  flex-direction: column;
  overflow: auto;
  height: 100%;
  width: 100%;

  /* Bottom gap is defined by the footer */
  padding: ${theme.spacings.sm} ${theme.spacings.sm} 0 ${theme.spacings.sm};
`
);
const StyledGrid = styled(Grid)`
  width: 100%;
  flex: 1;
  margin-bottom: 10px;
`;
const PageContentLayout = ({
  children = null,
  className = void 0,
  FooterComponent = Footer,
  NotificationsComponent = WithGlobalAppNotifications
}, ref) => {
  const { enabled } = useFooterCustomization();
  return /* @__PURE__ */ React.createElement(Container, { className, ref }, /* @__PURE__ */ React.createElement(NotificationsComponent, null, /* @__PURE__ */ React.createElement(StyledGrid, { fluid: true, className: "page-content-grid" }, children || /* @__PURE__ */ React.createElement(Outlet, null)), /* @__PURE__ */ React.createElement(React.Fragment, null, enabled && /* @__PURE__ */ React.createElement(FooterComponent, null))));
};
export default React.forwardRef(PageContentLayout);
